import React from 'react';
import './Button.css';

/**
 * Componente Button reutilizable
 * @param {string} variant - Variante del botón: 'primary', 'secondary', 'outline'
 * @param {string} size - Tamaño: 'sm', 'md', 'lg'
 * @param {boolean} fullWidth - Si el botón debe ocupar todo el ancho
 * @param {function} onClick - Función a ejecutar al hacer click
 * @param {boolean} disabled - Si el botón está deshabilitado
 * @param {ReactNode} children - Contenido del botón
 */
const Button = ({
    variant = 'primary',
    size = 'md',
    fullWidth = false,
    onClick,
    disabled = false,
    type = 'button',
    children
}) => {
    const classNames = [
        'btn',
        `btn--${variant}`,
        `btn--${size}`,
        fullWidth ? 'btn--full-width' : '',
    ].filter(Boolean).join(' ');

    return (
        <button
            className={classNames}
            onClick={onClick}
            disabled={disabled}
            type={type}
        >
            {children}
        </button>
    );
};

export default Button;
